// extracted by mini-css-extract-plugin
export var legendIndicator = "_ea-1";
export var legendRight = "_ea-0";